import type { CommentAction } from '@confluence/inline-comments-common/entry-points/inlineCommentsTypes';

export const DEFAULT_TOP_LEVEL_ACTIONS_WITHOUT_DELETE = ['edit', 'resolve'] as CommentAction[];
export const DEFAULT_TOP_LEVEL_ACTIONS = [
	...DEFAULT_TOP_LEVEL_ACTIONS_WITHOUT_DELETE,
	'delete',
] as CommentAction[];
export const RESOLVED_TOP_LEVEL_ACTIONS = ['reopen'] as CommentAction[];
